import { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { getStoredLanguage, normalizeLanguage, setStoredLanguage } from '../lib/language';

const LanguageContext = createContext({
  language: 'english',
  setLanguage: () => {},
  isHindi: false,
});

export function LanguageProvider({ children }) {
  const [language, setLanguageState] = useState(() => getStoredLanguage());

  const setLanguage = useCallback((next) => {
    const lang = setStoredLanguage(next);
    setLanguageState(lang);
  }, []);

  const value = useMemo(
    () => ({
      language,
      setLanguage,
      isHindi: language === 'hindi',
    }),
    [language, setLanguage]
  );

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}

export { normalizeLanguage };
